import script from "./BaseCollapsible.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCollapsible.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCollapsible.vue?vue&type=style&index=0&id=197463e6&lang=scss"

const __exports__ = script;

export default __exports__